import '../../scss/widgets/widget-coin-core-info.scss';
import widgetsDataService from '../services/widgetsDataService.js'

const coinCoreInfo = {
    async updateDynamicsData() {
        let widgets = $('.widget-basic-info-coin');
        let data = widgets.data();

        let widgetData = await widgetsDataService.fetchWidgetDataAsync('getCoinCoreInfoData', data.coinId, data.currency);
        widgetsDataService.updateDataOnPage(`.widget-basic-info-coin.${data.coinId}`, widgetData);

        let widgetExchangeData = await widgetsDataService.fetchWidgetDataAsync('getCoinCoreInfoExchangeData', data.coinId);
        if (widgetExchangeData?.exchanges) {
            Object.entries(widgetExchangeData.exchanges).forEach(([exchangeId, exchangeData]) => {
                widgetsDataService.updateDataOnPage(
                    `.block-exchanges-buy__item[data-field="${exchangeId}"]`,
                    exchangeData
                );
            });
        }
    }
}

export default coinCoreInfo;
